module.exports = __webpack_public_path__ + "img/Vector.46b8765d.svg";